// src/components/AppShell/Sidebar.tsx
import { NavLink, Link } from 'react-router-dom';
import { useAuth } from '../../lib/AuthContext';
import './AppShell.css';

const NAV_ITEMS = [
  { path: '/overview', label: 'Overview' },
  { path: '/commands', label: 'Commands' },
  { path: '/permissions', label: 'Permissions' },
  { path: '/market-alerts', label: 'Market Alerts' },
  { path: '/clan-events', label: 'Clan Events' },
  { path: '/clan-watches', label: 'Clan Watches' },
  { path: '/reports', label: 'Reports' },
  { path: '/channels', label: 'Channels' },
  { path: '/logs', label: 'Logs' },
  { path: '/settings', label: 'Settings' },
];

// Bot Health moved here from NAV_ITEMS (2026-07-14) - no longer
// visible to regular users. Owner Admin split from one nav item into
// several, matching the actual separate pages it's now built as.
const CREATOR_NAV_ITEMS = [
  { path: '/bot-health', label: 'Bot Health' },
  { path: '/owner-admin/overview', label: 'Owner Overview' },
  { path: '/owner-admin/servers', label: 'Servers' },
  { path: '/owner-admin/reports', label: 'Bug Reports' },
  { path: '/owner-admin/logs', label: 'Server Logs' },
  { path: '/owner-admin/creator-logs', label: 'Creator Audit' },
  { path: '/owner-admin/announcements', label: 'Announcements' },
  { path: '/owner-admin/config', label: 'Config' },
];

export function Sidebar() {
  const { user } = useAuth();

  return (
    <nav className="sidebar" aria-label="Dashboard navigation">
      <div className="wordmark">
        Idle<span>Hub</span>
      </div>

      <ul className="nav-list">
        {NAV_ITEMS.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <span className="nav-item__dot" aria-hidden="true" />
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>

      {user?.isCreator && (
        <>
          <div className="nav-divider" />
          <div className="nav-owner-label">Bot owner only</div>
          <ul className="nav-list">
            {CREATOR_NAV_ITEMS.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => `nav-item owner-only${isActive ? ' active' : ''}`}
                >
                  <span className="nav-item__dot" aria-hidden="true" />
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </>
      )}

      <div className="sidebar__footer">
        <Link to="/privacy" className="sidebar__footer-link">Privacy policy</Link>
      </div>
    </nav>
  );
}
